import React from "react";

import Mobileheader from "../component/Mobiledashboard/Mobileheader";
import Mobilenav from "../component/Mobiledashboard/Mobilenav";


const Mobileabouts = () => {


  return (
    <div className="h-[1000px]  px-6 bg-[radial-gradient(89.62%_213.03%_at_38.75%_80.3%,_#07031C_0%,_#241D4A_30.52%,_#07031C_64.32%)]">
      <Mobileheader className="mt-[30px]"/>
      <div className="px-6 py-6 mt-10  grid gap-12">
        <h2 className="text-white text-[30px] font-[istok] font-[900]">About Us</h2>

        <h2 className="text-[#D4F5F9] text-[25px] font-[istok] font-[900]">Welcome to
        Capital Nest</h2>

        <p className=" text-justify text-white font-lato text-[20px]">

        At Capital Nest, we believe that everyone should have the freedom to
earn, hold, and invest their money in cryptocurrency without any hassle
- no matter their level of understanding of cryptocurrency.
        </p>


      </div>
      <Mobilenav />
    </div>
  );
};

export default Mobileabouts;
